import Trinity from '@core/scripts/components/trinity-adapter.js';
import Device from '@core/scripts/components/device.js';

const TrinityObjects = {
  Teaser: 'teaser',
  Video: 'video',
};

export const TrinityEvents = {
  sendVideoActionClick: (eventAttributes) => {
    Trinity.sendTrinityEvent({
      schema: {
        version: 1,
        name: 'CLICK_VIDEO_TEASER',
      },
      attributes: {
        ...eventAttributes,
        isApp: Device.isApp(),
        object: TrinityObjects.Video,
      },
    });
  },
  /**
   *
   * @param eventAttributes typeof {teaserPageEntryId: string,
   * id:string,
   * cfEnvironment:string,
   * teaserId?: string,
   * pageViewId: string,
   * wkorbId: string,
   * page: string}
   */
  sendTeaserClick: (eventAttributes) => {
    Trinity.sendTrinityEvent({
      schema: {
        version: 1,
        name: 'CLICK_TEASER_BASIC',
      },
      attributes: {
        page: eventAttributes.page,
        cfEnvironment: eventAttributes.cfEnvironment,
        teaserId: eventAttributes.teaserId,
        pageViewId: eventAttributes.pageViewId,
        wkorbId: eventAttributes.wkorbId,
        isApp: Device.isApp(),
        object: TrinityObjects.Teaser,
        teaserPageEntryId: eventAttributes.teaserPageEntryId,
        id: eventAttributes.id
      },
    });
  },

  /**
   *
   * @param eventAttributes typeof {itemId: string,
   * shopId?: number,
   * carouselName: 'video_carousel',
   * digistyleId: string,
   * functionId: 18| 19 | 20},
   * pageViewId: string,
   * wkorbId: string
   * page: 'article_detail' | 'home' |'canal' | 'wishlist' | 'article_overview' | 'search'
   */
  sendProductSliderClick: (eventAttributes) => {
    Trinity.sendTrinityEvent({
      schema: {
        version: 1,
        name: 'CLICK_CAROUSEL_TEASER',
      },
      attributes: {
        isApp: Device.isApp(),
        object: TrinityObjects.Teaser,
        itemId: eventAttributes.itemId,
        carouselName: eventAttributes.carouselName,
        digistyleId: eventAttributes.digistyleId,
        functionId: eventAttributes.functionId,
        pageViewId: eventAttributes.pageViewId,
        wkorbId: eventAttributes.wkorbId,
        page: eventAttributes.page,
      },
    });
  },

  /**
   *
   * @param eventAttributes typeof {
   * teaserId: string,
   * watchTime: number,
   * pageViewId: string,
   * wkorbId: string
   * page: 'article_detail' | 'home' |'canal' | 'wishlist' | 'article_overview' | 'search'
   * }
   */
  sendVideoWatchtime: (eventAttributes) => {
    Trinity.sendTrinityEvent({
      schema: {
        version: 1,
        name: 'VIDEO_TEASER_WATCHTIME',
      },
      attributes: {
        ...eventAttributes,
        isApp: Device.isApp()
      },
    });
  },

  /**
   *
   * @param eventAttributes typeof {
   * numberOfPicture: number,
   * viewName: 'ugc_teaser',
   * pageViewId: string,
   * wkorbId: string
   * page: 'article_detail' | 'home' |'canal' | 'wishlist' | 'article_overview' | 'search'
   * }
   */
  sendFlowboxTeaserView: (eventAttributes) => {
    Trinity.sendTrinityEvent({
      schema: {
        version: 1,
        name: 'VIEW_TEASER_UGC',
      },
      attributes: {
        ...eventAttributes,
        viewName: 'ugc_teaser',
        isApp: Device.isApp()
      },
    });
  },

  /**
   *
   * @param eventAttributes typeof {
   * clickName: 'ugc_teaser',
   * object: 'teaser',
   * pageViewId: string,
   * wkorbId: string
   * page: 'home' |'canal'
   * }
   */
  sendFlowboxTeaserClick: (eventAttributes) => {
    Trinity.sendTrinityEvent({
      schema: {
        version: 1,
        name: 'CLICK_TEASER_UGC',
      },
      attributes: {
        ...eventAttributes,
        clickName: 'ugc_teaser',
        object: 'teaser',
        isApp: Device.isApp()
      },
    });
  },

  /**
   *
   * @param eventAttributes typeof {
   * articleNumber: number,
   * clickName: 'to_product',
   * object: 'teaser',
   * pageViewId: string,
   * wkorbId: string
   * page: 'home' |'canal'
   * }
   */
  sendFlowboxTeaserLayerClick: (eventAttributes) => {
    Trinity.sendTrinityEvent({
      schema: {
        version: 2,
        name: 'CLICK_LAYER_UGC',
      },
      attributes: {
        ...eventAttributes,
        clickName: 'to_product',
        object: 'teaser',
        isApp: Device.isApp()
      },
    });
  }


};
